export const QA_NAME_GENERATE_SUMMARY_BUTTON = 'generateSummary'
